/** Shared CSV cell encoding (Excel-friendly, formula-injection safe). */

const FORMULA_PREFIX = /^[\s]*[=+\-@]|^[\t\r\n']/;

/** Quotes a cell and prefixes `'` when Excel would treat it as a formula. */
function encodeCsvCell(value: string): string {
  const safe = FORMULA_PREFIX.test(value) ? `'${value}` : value;
  return `"${safe.replaceAll('"', '""')}"`;
}

/** Reverses the formula guard added by {@link encodeCsvCell}. */
export function decodeCsvCell(value: string): string {
  return value.startsWith("'") && FORMULA_PREFIX.test(value.slice(1)) ? value.slice(1) : value;
}

/** Builds a `;`-separated CSV with a UTF-8 BOM, as the Nordic Excel locale expects. */
export function buildCsv(rows: string[][]): string {
  return "﻿" + rows.map((row) => row.map(encodeCsvCell).join(";")).join("\r\n") + "\r\n";
}
